#### Replay webhook subscriptions

We’ve extended [webhook subscriptions] with a new mutation [`replayWebhookSubscription`],
which resends undelivered events from the past 90 days to your subscription endpoint.

This makes it easy for you to recover from downtime without building a bespoke replay mechanism on top of the [`events`](/schema/query/events) query.

```graphql
mutation ($input: ReplayWebhookSubscriptionInput!) {
  replayWebhookSubscription(input: $input) {
    webhookSubscription {
      id {
        value
      }
    }
  }
}
```

```json
{
  "input": {
    "webhookSubscription": {
      "id": "seekAnzPublicTest:webhookSubscription:events:BoJiJ9ZWFVgejLXLJxUnvL"
    },
    "filter": {
      "createdAfterDateTime": "2021-01-02T00:00:00.000Z",
      "createdBeforeDateTime": "2021-01-05T00:00:00.000Z",
      "replayDeliveredEventsIndicator": false
    }
  }
}
```

[webhook subscriptions]: /events/webhooks#replaying-a-subscriptions-events
[`replaywebhooksubscription`]: /schema/mutation/replayWebhookSubscription
